export default {
  home: {
    Home: 'Live',
    Hot: 'Hot',
    Match: 'Schedule',
    Message: 'Messages',
    Friend: 'Friends',
    Me: 'Me',
    Tab_0: 'Recommend',
    Tab_1: 'Football',
    Tab_2: 'Basketball',
    Tab_3: 'Esports',
    Tab_4: 'News',
    Tab_5: 'Midnight',
    Tab_6: 'Replay',
    index_title_zb: 'Live Now',
    index_title_jc: 'Highlights',
    index_title_mx: 'Star Anchors',
    index_title_qq: 'Esports',
    index_title_kx: 'Today\'s News',
    more: 'More',
    jrrm: 'Today\'s Hot',
    jumpTop: 'Back to Top',
    onFocus: 'Follow',
    reply: 'replies',
    allComment: 'All Comments',
    remen: 'Hot',
    saiguo: 'Results',
    bsjj: 'Match Highlights',
    qwzk: 'Most Complete Events · Fastest Playback',
    lggg: 'Free Download for HD and Casting',
    downapp: 'Download App',
    anchortalk: 'Anchor Commentary',
    currentsound: 'Live Sound',
    movieplayback: 'Replay',
    hightqulity: 'HD',
    pushlish: 'Publish',
    abautanchor: 'Related Anchors',
    areadyfocus: 'Followed',
    focus: 'Follow',
    abautlive: 'Related Live',
    abautmatch: 'Related Schedule',
    yi: 'Billion',
    wan: 'Million',
    unkowntype: 'Unknown Type',
    ballcircle: 'Ball Circle',
    staranchor: 'Star Anchors',
    renhot: 'Popularity: ',
    veryonesearch: 'Everyone is Searching',
    searchplace: 'Search for content of interest',
    zhongyao: 'Anchor',
    worldCupSchedule: 'Schedule',
    worldCupScore: 'Scores',
    worldCupNews: 'News',
    tabIdx: '1',
  },
  play: {
    chat: "Chat",
    userzb: "Anchor",
    saik: "Match",
    zr: "Lineup",
    zs: "Index",
    zb: "Live",
    fx: "Analysis",
    zbNoLine: 'The anchor is not live',
    zbNoLine2: 'Follow the anchor to get live notifications～',
    joinInRoom: 'Joined the chat room',
    textLive: 'Text Live',
    tongji: 'Technical Statistics',
    team: 'Team',
    teamTj: 'Team Statistics',
    teamUserTj: 'Player Statistics',
    yz: "Asian Handicap",
    rq: "Handicap",
    jqs: "Goals",
    zf: "Total Points",
    zlly: "Odds Source",
    fhv: "Return Rate",
    win: "Win",
    draw: "Draw",
    owe: "Lose",
    number: 'Number',
    teamUser: 'Player',
    starter: 'Starting',
    time: 'Time',
    score: 'Score',
    lb: 'Rebounds',
    zg: 'Assists',
    tl: 'Shooting',
    sanfen: 'Three Points',
    fq: 'Free Throws',
    qd: 'Steals',
    qb: 'Offensive Rebounds',
    hb: 'Defensive Rebounds',
    gm: 'Blocks',
    sw: 'Turnovers',
    fg: 'Fouls',
    chatText: 'Chatting makes the game more fun~',
    gxzg: 'Highest in Each Category',
    lsjz: 'Historical Matches',
    sv: 'Win Rate',
    ypl: 'Win Rate',
    dql: 'Big Ball Rate',
    ying: 'Win',
    shu: 'Lose',
    zou: 'Push',
    xiao: 'Small',
    da: 'Big',
    jqzt: 'Recent Form',
    tss: 'Same Event',
    rqss: 'Date/Event',
    dz: 'Matchup',
    dx: 'Size',
    copyline: 'Copy Link',
    sixin: 'Private',
    fensi: 'Fans',
    fds: 'Please remember the backup domain to avoid loss',
    ordownapp: 'Or download the app',
    lodingtext: 'Chat is loading',
    disstartmatch: 'Time until match starts',
    zhu: 'Home',
    ke: 'Away',
    chatHost: 'Contact Customer Service'
  },
  match: {
    jumpNowDay: 'Back to Today',
    refresh: 'Refresh',
    mathDay: 'Event Date',
    ban: 'Half',
    jiao: 'Corner',
    huangguan: 'Crown',
    libo: 'Ladbrokes',
    mingh: 'Mansion',
    bocai: 'Macau',
    wlxe: 'William Hill',
    ysb: 'Easybet',
    wd: 'Wade',
    lij: 'Liji',
    yih: 'Yinghe',
    pb: 'Pinnacle',
    year: 'Year',
    moon: 'Month',
    nowDay: 'Today',
    onlive: 'Live',
    dej: '2nd Quarter',
    matcherr: 'Match Exception',
    nomatch: 'Not Started',
    dyj: '1st Quarter',
    dyjo: '1st Quarter End',
    dejo: '2nd Quarter End',
    dsj: '3rd Quarter',
    dsjo: '3rd Quarter End',
    dsjj: '4th Quarter',
    matchjs: 'Overtime',
    matchwc: 'Full Time',
    matchtc: 'Postponed',
    matchzd: 'Interrupted',
    matchyz: 'Abandoned',
    matchdd: 'Pending',
    matchsfqrqs: '3-Point Goals',
    matchefqrqs: '2-Point Goals',
    matchfqjqs: 'Free Throw Goals',
    matchsyzts: 'Remaining Timeouts',
    matchfgs: 'Fouls',
    matchfqmzl: 'Free Throw Percentage',
    matchzzts: 'Total Timeouts',
    matchzg: 'Attack',
    matchwxjg: 'Dangerous Attack',
    matchkql: 'Possession',
    matchszqm: 'Shots on Target',
    matchjq: 'Goals',
    matchdq: 'Penalty',
    matchzg1: 'Assists',
    matchtime: 'Time',
    matchhp: 'Red Card',
    matchhp2: 'Yellow Card',
    matchsm: 'Shots',
    matchsz: 'Shots on Target',
    matchgr: 'Dribbles',
    matchgrcg: 'Successful Dribbles',
    matchjw: 'Clearances',
    matcyxzd: 'Effective Blocks',
    matclj: 'Interceptions',
    matcqd: 'Tackles',
    matccq: 'Passes',
    matccqcg: 'Successful Passes',
    matchczq: 'Crosses',
    matchczqcg: 'Successful Crosses',
    matchcco: 'Long Passes',
    matchccok: 'Successful Long Passes',
    matchpq: 'Duels',
    matchpqcg: 'Successful Duels',
    matchdqe: 'Lost Balls',
    matchfg: 'Fouls',
    matchbqf: 'Fouled',
    matchpj: 'Saves',
    matchqjq: 'Punches',
    matchsmycj: 'Goalkeeper Rush',
    matchcjcg: 'Successful Rush',
    matchgkcj: 'Aerial Rush',
    matchpf: 'Rating',
    matchjqs: 'Corners',
    matchjwq: 'Throw-ins',
    matchryq: 'Free Kicks',
    matchqmq: 'Goal Kicks',
    matchhr: 'Substitutions',
    matchbsks: 'Match Started',
    matchzc: 'Half Time',
    matchjsg: 'End',
    matchbcbf: 'Half Time Score',
    matchlhbh: 'Two Yellows to Red',
    matchdqwj: 'Missed Penalty',
    matchwlq: 'Own Goal',
    matchstbs: 'Injury Time',
    matchsp: 'Shots Off Target',
    matchjssjs: 'Overtime End',
    matchjdqdz: 'Penalty Shootout End',
    matchvar: 'VAR',
    matchspqm: 'Shots Off Target',
    matchzysj: 'Key Events',
    matchjss: 'Overtime',
    matchdqjs: 'Penalty Shootout',
    no: 'No',
    chang: 'Match',
    tzk: 'Same Home/Away',
    yes: 'Yes',
    nos: 'No',
    xiaojie: 'Quarter',
    noLiveMatch: 'Not Live Yet',
  },
  noData: {
    noComment: 'No comments yet, share your thoughts',
    noSearch: 'No search results',
    noMatch: 'No matches currently',
    nobifen: 'No score data yet',
    noLive: 'Check out other live streams',
    nogroup: 'No groups added yet',
    noNewfriend: 'No new friends added',
    noqgg: 'Explore and follow your favorite anchors',
    nozb: 'No followed anchors yet',
    noMsg: 'No messages',
  },
  tips: {
    shareMatch: 'Match shared successfully',
    copySuccess: 'Copied successfully',
    changeLine: 'Switch video line',
    line: 'Line',
    cancel: 'Cancel',
    tosendZb: 'Tell the anchor to join the group',
    tosendhd: 'Interact with the anchor',
    addzb: 'Add anchor as friend for predictions and recommendations',
    gd: 'More anchors waiting for you to add～',
    tickoutgroup: 'You have been removed from the group',
    youforbid: 'You have been muted',
    younotin: 'Chat room does not exist',
    nomoredata: 'No more data',
    month: 'Month',
    day: 'Day',
    today: 'Today',
    kkry: 'Empty~',
    ptaddress: 'Platform Backup URL',
    downloadApp: 'Download App',
    qwzk: 'Most Complete Events · Fastest Playback',
    lgtp: "Free Download for HD and Casting",
    myInvite: 'My Invitations',
    gjyaoqing: 'Total Invitations:',
    copyInviteLink: 'Copy Invitation Link',
    person: 'People',
    chatcontent: 'Chat Content',
    addHomeScreen: 'Add to Home Screen',
    beat40: "You have beaten 40% of users nationwide",
    beat60: "You have beaten 60% of users nationwide",
    beat78: "You have beaten 78% of users nationwide",
    beat88: "You have beaten 88% of users nationwide",
    beat98: "You have beaten 98% of users nationwide",
    haicha: 'Still need',
    czzksj: 'Growth points to upgrade',
    forbid: 'Muted',
    loadFail: 'Load failed',
    notSuport: 'Your browser does not support video',
    forwardApp: 'Message type not supported, please check in app',
    photo: 'Photo',
    video: 'Video',
    file: 'File',
    redpot: 'Red Packet',
    upload: 'Uploading',
    uploadFail: 'Upload failed!',
    yybtcql: 'You have been removed from the group',
    yybjy: 'You have been muted',
    ltsbcz: 'Chat room does not exist',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    search: 'Cancel',
  },
  im: {
    edit: 'Edit',
    search: 'Search',
    inputPlaceholder: 'Enter search keywords',
    allin: 'All',
    add: 'Add',
    group: 'Group Chat',
    agree: 'Agreed',
    reject: 'Rejected',
    pass: 'Pass',
    subitFriend: 'Add as Friend',
    activity: 'Activity Center',
    sedkf: 'Share your thoughts',
    allSel: 'Select All',
    yidu: 'Mark as Read',
    wanc: 'Done',
    online: 'Online',
    nowonline: 'Currently Online',
    latestonline: 'Recently Online',
    contact: 'Contacts',
    newFriend: 'New Friends',
    mygfoup: 'My Groups',
    mygscj: 'I am your best happiness collector',
    wntuij: 'Recommended for You',
    sound: '[Voice]',
    video: '[Video]',
    image: '[Image]',
    redpot: '[Red Packet]',
    link: '[Link]',
    card: '[Card]',
    getredpot: '[Get Red Packet]',
    getreadysound: '[Ready for Real-Time Voice]',
    transfer: '[Transfer]',
    groupcard: '[Group Card]',
    recall: 'Recall Message',
    checkorder: '[Confirm Order]',
    file: '[File]',
    zfhxx: '[Payment Message]',
    pay: '[Mini Program]',
    ad: '[Ad]',
    talkover: '[Call Ended]',
    tips: '[Tip]',
    grouptips: '[Group Application Tip]',
    groupconfirm: '[Group Application Confirmation]',
    notyoufriend: '[Not Your Friend]',
    linknotyoufriend: '[Invite Link to Join Group]',
    groupsend: '[Group Send]',
    groupNotice: 'Group Notice',
    shouqi: 'Collapse',
    zhangkai: 'Expand',
    groups: 'Groups'
  },
  me: {
    onLogin: 'Click to Login',
    tipsregst: 'Register to participate in more activities and benefits',
    sign: 'Sign In',
    onsign: 'Signed In',
    jfsc: 'Points Mall',
    zbxg: 'Anchor Related',
    gkls: 'Watch History',
    wddj: 'My Level',
    yqhy: 'Invite Friends',
    zxkf: 'Online Customer Service',
    zxzh: 'Logout Account',
    yqhydjf: 'Invite Friends to Earn Points',
    yjfk: 'Feedback',
    gywm: 'About Us',
    setting: 'Settings',
    lvxl: 'Rookie',
    lvht: 'Bronze',
    lvby: 'Silver',
    lvhj: 'Gold',
    lvbj: 'Platinum',
    lvzs: 'Diamond',
    lvbyqt: 'Silver Ball Boy',
    lvhtqm: 'Bronze Fan',
    lvhjqy: 'Gold Player',
    lvbjqx: 'Platinum Star',
    lvzsqw: 'Diamond King',
    srmi: 'Enter Password',
    qdcg: 'Sign In Success',
    jfgz: 'Points Rules',
    text3: '3: Watch matches for 10 minutes daily',
    text1: '1: The Points Mall is a free benefit provided by our platform for users. As long as you become our user, you can earn points. Points can be used to exchange for valuable gifts or platform benefits.',
    text1_2: '1: The Points Mall is a free benefit provided by our platform for users. As long as you become our user, you can earn points. Points can be used to exchange for valuable gifts.',
    sigin1: 'This user is lazy and has not filled in a personal bio',
    quxiaocg: 'Cancel Success',
    fzfxlj: 'Copy Share Link',
    addimg: 'Add Image',
    zonecode: 'Area Code',
    zonecodedef: '86',
    inputphone: 'Enter your phone number',
    videohp: 'Video Screen Black',
    mbf: 'No Score',
    sxcg: 'Refresh Success',
    qsrplnr: 'Enter comment content',
    srname: 'Enter your name',
    tgcggg: 'Submitted successfully, staff will contact you later',
    zbxxsc: 'Anchor Info Upload',
    qsrsfz: 'Enter ID number',
    zbnoid: 'Anchor has no ID set',
    gzzb: 'Follow Anchor',
    lxkf: 'Contact Customer Service',
    phone: 'Phone Number',
    code: 'Verification Code',
    dxyzm: 'SMS Verification Code',
    hqyzm: 'Get Verification Code',
    symmdl: 'Use Password Login',
    dl: 'Login',
    wyydbty: 'I read and agree',
    rjfwyx: '《Software License and Service Agreement》',
    zhen: 'Account',
    inputname: 'Enter account',
    jxgg: 'Continue Exploring',
    yzmdl: 'Verification Code Login',
    mm: 'Password',
    qsrnc: 'Enter nickname',
    jrqdhd: 'Today\'s Sign In Reward',
    textnone: '1. How to Earn Points',
    text4: '4: Invite new users to share the app',
    text2: '2: Mall items can only be exchanged with points, not with cash or other methods.',
    signname: 'Signature',
    gzcg: 'Follow Success',
    fzljcg: 'Copy Success',
    zdyz: '(Max 1)',
    submit: 'Submit',
    mflt: 'Can\'t Chat',
    bsts: 'Too Few Matches',
    abouttext1: 'As a new generation of comprehensive internet sports media platform, we have the rights to over 50 major domestic and international sports events including Chinese Super League, AFC Champions League, Premier League, Serie A, Ligue 1, La Liga, UEFA Champions League, European Cup, World Cup, etc., becoming a platform for a large number of vertical sports users to watch and interact with sports events.',
    tpisnodata: 'You haven\'t entered any content',
    plcg: 'Comment Success',
    srndsjh: 'Enter your phone number',
    oninutphone: 'Please enter the correct phone number',
    zjhm: 'ID Number',
    tccg: 'Logout Success',
    mhtcsy: 'seconds back to home',
    nrwk: 'Content is empty',
    tyfwxy: 'Please agree to the service agreement',
    qsrmm: 'Enter password',
    newpass: 'New Password',
    inputnewpass: 'Enter new password',
    grzl: 'Personal Info',
    avatar: 'Avatar',
    username: 'Nickname',
    gxqm: 'Personal Signature',
    nosetting: 'Not Set',
    xtavatar: 'System Avatar',
    xc: 'Album',
    qxztx: 'Please select avatar',
    wjbncg: 'File size cannot exceed 1m',
    imgsubimterr: 'Image upload failed, please try again later',
    tpscz: 'Image uploading',
    qscjpg: 'Please upload jpg/png format images',
    scz: 'Uploading...',
    hqsb: 'Failed to get system avatar',
    szcg: 'Set Success',
    sznc: 'Set Nickname',
    xlqd: 'You have signed in for',
    tian: 'days',
    mrqd1: ' 1: Daily Sign In',
    mrqd2: ' (Sign in for 7 consecutive days to get extra points)',
    aboutjfsc: '2. About Points Mall',
    jfdhjp: '3: Points exchange for prizes requires correct address, phone number, and recipient. Our platform will cover nationwide shipping.',
    mygdl: 'No more',
    zzzb: 'Live',
    fklex: 'Feedback Type',
    fkcgprd: '(Successful feedback may receive benefits)',
    tgcg: 'Submit Success',
    syhm: 'Sound and Video Out of Sync',
    cpty: 'Product Experience',
    testx1: 'Dedicated to building an internet sports platform serving global fans, we have innovatively launched a vertical independent sports app, enhancing interaction and creating richer, more comprehensive sports content, achieving 7x24-hour full-time consulting services.',
    ltpf: 'Chatting too frequently, please try again later~',
    mmbns6: 'Password cannot be less than 6 characters',
    srxxdz: 'Enter your detailed address',
    qzqtx: 'Please fill in the correct information',
    qsrzsmz: 'Enter real name',
    nylqgl: 'You have already claimed',
    nccccc: '1. Nickname can only be changed once a day, no more than 6 characters.',
    textnc: '2. Nickname can only be in Chinese',
    textnc3: '3. After successful nickname change, if it violates rules after manual review, it will be reset.',
    ncxt: 'Nickname is the same, please modify and submit again',
    ncbnwk: 'Nickname cannot be empty',
    idszh: 'ID is the unique credential of the account and cannot be changed',
    szgxqm: 'Set Personal Signature',
    qsrgxqm: 'Enter your personal signature',
    qsxt: 'Signature is the same, please modify and submit again',
    qsbnwk: 'Signature cannot be empty',
    jfgza: 'Rules',
    lxqdyjx: 'Consecutive Sign In for Surprise Gifts',
    jfmx: 'Points Details',
    jfdhzq: 'Points Exchange Zone',
    ckwdhd: 'Check My Exchanged Items',
    jfci: 'Points/Time',
    jf: 'Points',
    dh: 'Exchange',
    dhsy: 'After exchanging with points, it cannot be revoked',
    ckkdh: 'Check Available Exchange Items',
    zbgphd: '2: Live Screen Interaction)',
    zbgphd2: '(Once daily)',
    smjfsc: 'What is Points Mall?',
    textp4: '4: The platform reserves the right to adjust the Points Mall rules and make announcements at any time. In case of activity loopholes or large-scale cheating, including but not limited to obtaining benefits through non-standard processes, the platform reserves the right to directly下线 the activity and retain the right to回收 benefits, and reserves the right to change these rules and terms.',
    qxgz: 'Unfollow',
    lsjl: 'History',
    fknr: 'Feedback Content',
    gxydkn: 'Encountered difficulties in updating',
    bstk: 'Matches look too laggy',
    qsrnyfk: 'Enter your feedback information',
    wl1: 'Future',
    wlyt: 'Will rely on the professionalism of event operations to explore cross-industry interconnections and build a full-scenario user service ecosystem. Focus on sports content interest circles, continue to serve sports users with leading industry IP operation capabilities, bring leading industry sports events, create sports content consulting, and build a sports health platform with attitude, making love more loved',
    xtts: 'System Tip: This live broadcast strives to create a positive and healthy live broadcast environment,巡查 live broadcast content 24 hours a day. Any behavior that传播 illegal,违规, fraud,低俗不良,血腥暴力封建迷信等信息 will result in the违规者账号 being封号处理.',
    chgangsu: 'Modify Success',
    inputcode: 'Enter your postal code',
    yazfa: 'Verification code sent',
    xingming: 'Name',
    lingquceng: 'Claim Success',
    loginSucces: 'Login Success',
    backhome: 'Back to Home',
    inputphonecode: 'Enter verification code',
    setPass: 'Set Password',
    yset: 'Set',
    out: 'Logout',
    setpasstips: 'After setting a password, you can log in directly with your account and password.',
    ok: 'Confirm',
    pssmy: 'Password Verification',
    zxhb: 'Special Red Packet',
    zxhbjf: 'Exclusive Points Red Packet',
    lq: 'Claim',
    ylq: 'Claimed',
    mystatk: 'My Tasks',
    mystat2k: 'Growth Points',
    qbtj: 'All Statistics',
    zbgg: 'Anchor Announcement',
    nozbgg: 'This anchor has not filled in the announcement',
    xianlu: 'Line',
    gxni: 'Congratulations on getting a cash red packet',
    gxsssni: 'Go to private message the anchor to claim～',
    loding: 'Data is loading, please wait～',
    yuan: 'Yuan',
    sedmsg: 'Sent you a message',
    chakan: 'View',
    del: 'Delete',
    sp: 'Rise',
    jp: 'Fall',
    gs: 'High Water',
    ds: 'Low Water',
    pkly: 'Odds Source',
    cspk: 'Initial Odds',
    jspk: 'Current Odds',
    qy: 'Player',
    sf: 'Starting',
    mtsc: '(3 times daily)',
    sq: 'Collapse',
    sfzr: 'Starting Lineup',
    tbzr: 'Substitute Lineup',
    zx: 'Formation',
    chu: 'Initial',
    ji: 'Current',
    lhyh: 'Two Yellows and a Red',
    wl: 'Own Goal',
    sjhgscw: 'Incorrect phone number format',
    inputsjyzm: 'Enter SMS verification code',
    inputzonecode: 'Enter area code',
    loginsuccback: 'Login success, back to home in 3 seconds',
    loginsucc: 'Login success,',
    threeback: 'seconds back to home',
    loginfail: 'Login failed.',
    welcome: 'Welcome to',
    logintips: 'Login directly with phone number, no registration required',
    integralExchange: "Exchange Success",
    integralSuccess: "Congratulations on successful exchange",
    integralExchanged: "Exchanged Points",
    integralNumber: 'Remaining Points',
    integralContinue: 'Continue Exchange',
    integralTips: '*Please complete your shipping address in the exchanged items, staff will confirm and ship automatically, no logistics information provided due to system reasons;',
    texttoolong: 'Characters cannot exceed 6',
    nickMdySucc: 'Nickname modified successfully',
    onlyUseChina: 'Nickname can only use Chinese characters, please re-enter',
    addaddress: 'Add Address',
    addressdetail: 'Enter your detailed address, area, and street information',
    inputdetail: '*Note: Ensure the item can be correctly delivered to your address, the address should be detailed, only one chance to fill, will be shipped within 1～3 working days after completion.',
    integralex: 'Obtained by points exchange',
    delaccount: "Please read carefully before deleting your account, reminder:",
    delaccontent1: "To prevent accidental operations, please confirm again whether to delete your account and confirm the impact after deletion. Here is a friendly reminder: deleting your account is an irreversible operation. It is recommended to back up all information related to the account and ensure that all services related to the account have been properly handled before finalizing the deletion. Including but not limited to:",
    delaccontent2: "1. The account's personal information and history (including avatar, username, published content, browsing history, etc.) will be permanently lost.",
    delaccontent3: "2. You will be unable to log in and use this account.",
    delaccontent4: "3. Third-party accounts related to this account, authorized to log in, or bound to this account will be permanently lost. You will be unable to log in and use the above services. Any virtual rights or benefits obtained will be considered forfeited and cannot be continued. You understand and agree that this App cannot assist you in recovering the above services. After deleting your account, the bound phone number will be unlinked and can be registered again. Please proceed carefully.",
    delaccontent5: "Enter the current complete UID and click confirm. Your account will be permanently deleted. Please consider carefully!!!",
    delaccontent6: "Please enter the complete UID",
    delaccontent7: "Please enter UID",
    delaccontent8: "The ID you entered is incorrect",
    submitted: 'Submitted',
    success: 'Success',
    failed: 'Failed',
    invitecode: 'Invitation Code',
    inputInviteCode: 'Optional',
    withdrawFailed: 'Exchange Failed',
    inputaccount: 'Please enter account (6-20 letters + numbers)',
    inputpassword: 'Please enter password (6-20 digits or letters)',
    inputpasswordagain: 'Please enter password again',
    accountInvalid: 'Account does not meet the规范',
    gotoLogin: 'Go to Login',
    gotoRegister: 'Go to Register',
    querenpwd: 'Confirm Password',
    inputnickname: 'Enter nickname',
    register: 'Register Now',
    pwsswordInvalid: 'Please enter the correct password',
    pwsswordNotSame: 'The two passwords entered are不一致',
    setAccPwd: 'Set Account Password',
    setAccPwdSubTitle: 'After setting successfully, you can log in with account password',
    inputOldPassword: 'Enter original password',
    newPassword: 'New Password',
    oldPassword: 'Old Password',
    passwordIsSame: 'New password cannot be the same as old password',
    accPwdError: 'Account or password is incorrect',
    nickNameErr: 'Nickname must be 6-20 letters, numbers, or common characters',
    accountRepeated: 'This account already exists',
    nicknameRepeated: 'This nickname already exists',
    setSucc: 'Set information successfully',
    regSucc: 'Registration success, auto-logging in',
    switchAccount: 'Switch Account',
  },
  'jinqiu': 'Goal',
  'focuSucc': 'Follow Success',
  'cancelFocus': 'Unfollow Success',
  'clearCache': 'Clear Cache',

  "复制": "Copy",
  "邀请的人数": "Number of Invitations",
  "查看记录": "View Records",
  "可兑换积分": "Redeemable Points",
  "兑换话费": "Redeem Credit",  // 更简洁的表达
  "兑换彩金": "Redeem Bonus",
  "立即邀请": "Invite Now",
  "记录": "Records",
  "好友记录": "Friend Records",
  "兑换记录": "Redemption Records",
  "兑换": "Redeem",
  "确认兑换奖金吗？": "Confirm to redeem bonus?",

  "规则": "Rules",
  "碎片": "Fragments",
  "转盘次数": "Spins",
  "奖品兑换": "Redeem",
  "每日奖励": "Daily Rewards",
  "每日登录JALALIVE并观看比赛": "Daily login JALALIVE & watch matches",
  "转盘机会 +1": "+1 Spin",
  "活动规则": "Event Rules",
  "确认兑换吗？": "Confirm redemption?",
  "谢谢惠顾": "Thank you",
  "恭喜您获得": "Congratulations!",
  "未达成": "Locked",
  "领取": "Claim",
  "已领取": "Claimed",
  "数据异常或网络异常": "Data or network error",
  "兑换成功": "Redemption successful",
  "兑换失败": "Redemption failed",
  "收下": "Accept",
  "立即参与": "Join",

  "兑换奖品":"Redeem Prize",
  "兑换积分":"Redeem Points",
  "兑换奖励":"Redeem Rewards",
  "前往JalaLive积分商城":"Go to JalaLive Points Mall",
  "积分可以去兑换商品":"Points can be redeemed for items",
  "前往":"Go",

  "非法手机号": "Invalid phone number",
  "发送短信失败": "Failed to send SMS",
  "温馨提示": "Friendly reminder",
  "您尝试登录的手机号已存在绑定的账号，请使用账号密码登录。平台即将移除手机号验证码登录方式": "This phone number is already linked to an account. Please log in with your account password. SMS login will be discontinued soon.",
  "我知道啦": "Got it",
  "通知": "Notification",
  "平台即将移除手机号验证码登录方式，系统已自动为您生成账号，请补全其他信息，后续请使用账号密码登录！": "SMS login will be removed soon. An account has been created for you. Please complete your profile and use your account password to log in.",
  "账号（不可更改）": "Account (cannot be changed)",
  "设置密码": "Set password",
  "请输入密码": "Please enter password",
  "设置邮箱（用于找回密码，可选）": "Set email (for password recovery, optional)",
  "请输入邮箱": "Please enter email",
  "忘记密码": "Forgot password?",
  "邮箱验证": "Email verification",
  "请输入验证码": "Please enter the code",
  "获取验证码": "Get code",
  "邮箱格式不正确": "Invalid email format",
  "温馨提示：如果您没有绑定过邮箱，请联系客服找回密码": "Reminder: If you haven't bound an email, please contact customer service to recover your password",
  "设置邮箱":"Set email",
  "温馨提示：绑定邮箱可用于找回密码":"Reminder: Binding an email can be used to recover your password",

  "奖品剩余：": "Prizes Remaining:",
  "VIP折扣说明": "VIP Discount Explanation",
  "VIP折扣": "VIP Discount",
  "无折扣": "No Discount",
  "折": "Discount",
  "查看VIP详情": "View VIP Details",
  "礼物折扣": "Gift Discount",
  "支付":"Pay",
  "竞猜": "Guess",
  "我的积分": "My Points",
  "竞猜记录": "Guess Records",
  "截止时间": "Deadline",
  "选择下注积分": "Select Bet Points",
  "下注": "Bet",
  "下注成功": "Bet Successful",
  "比赛": "Match",
  "竞猜结果": "Guess Result",
  "竞猜成功": "Guess Successful",
  "竞猜失败": "Guess Failed",
  "等待中": "Waiting",
  "投注失败，积分不足": "Bet failed, insufficient points",
  // English

  "（主）": "(Home)",
  "（客）": "(Away)",
  "主队赢": "Home Wins",
  "平": "Draw",
  "客队赢": "Away Wins",
  "版本":"version",
  "查看详情":"View Details",
  "(在线中…)": "(Online...)",
  "暂无群组": "No groups",
  "暂无与主播私聊信息": "No private messages",
  "请找主播添加您进群获得福利": "Message the host to join and get perks",
  "请私信主播吧~": "DM the host~",
  "主播私聊": "Host DM",
  "群组": "Groups",
  "发送":"Send",

  "您的聊天已受限，请联系主播或客服":"Chat restricted. Contact the host or support.",
  "发送失败，未知错误":"Send failed. Unknown error.",
};
